import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/app/app/middleware/auth.global.ts";
import canonical_45redirect_45global from "/app/app/middleware/canonical-redirect.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  canonical_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}